export const appName = "import-installations-ui";
